export enum SURVEY_STEPS {
  MOTIVATION = 'MOTIVATION',
  EXPECTED_SUCCESS = 'EXPECTED_SUCCESS',
  INITIAL_EXPECTATION = 'INITIAL_EXPECTATION'
}

export const INITIAL_PROGRESS_BAR_VALUE = 0

export const HALF_CONCLUDED_PROGRESS_BAR_VALUE = 50

export const CONCLUDED_PROGRESS_BAR_VALUE = 100
